module.exports = __webpack_public_path__ + "img/avatar-me-sad.0d3da7b6.svg";